import type { State } from '@/components/control/types';
import type { SlideValidation } from './slider.types';
import { createSelector } from '@reduxjs/toolkit';
import SliderSlice from './slider.slice';

export const selectValidationByKey = (
  key: string,
  fb: SlideValidation = { required: false, dirty: false, messages: [] },
) => {
  return createSelector([SliderSlice.selectors.validation], (validation) => validation[key] || fb);
};

export const selectAnswersDefaultByKey = (key: string, fb: string = '') => {
  return createSelector([SliderSlice.selectors.answersDefault], (answersDefault) => answersDefault[key] || fb);
};

export const selectAnswersDirectByKey = (key: string, fb: string = '') => {
  return createSelector([SliderSlice.selectors.answersDirect], (answersDirect) => answersDirect[key] || fb);
};

export const selectCurrentQuestionCanGoNext = (key: string) =>
  createSelector([selectValidationByKey(key)], (validation) => {
    return validation.required ? validation.messages.length === 0 : true;
  });

export const selectControlStateByKey = (key: string) =>
  createSelector([selectValidationByKey(key), selectAnswersDefaultByKey(key)], (validation, answerDefault): State => {
    const hasValidationErrors = validation.messages.length > 0;
    const isAnswered = answerDefault !== '';
    if (validation.required && validation.dirty && hasValidationErrors) return 'error';
    if (isAnswered && !hasValidationErrors) return 'success';
    return 'idle';
  });
